export const getCompanyData = data => {
  const { conflictOfInterests, l4, l5 } = data;
  const level = l5.available ? 'L5' : 'L4';
  const product = l5.available ? l5 : l4;
  const isPublicRating = l5.available;
  const isRatingSubscription = l4.available;
  const { ratings } = product;
  const showRatings = !conflictOfInterests && ratings.length > 0;
  const showRequestRatingBox = !product.available || !ratings.length;
  const showConflictOfInterests = product.purchased && conflictOfInterests;
  const showRatingRequestInProgress =
    product.purchased && !product.approved && !conflictOfInterests;

  return {
    ratings,
    level,
    isPublicRating,
    isRatingSubscription,
    showRatings,
    showRequestRatingBox,
    showConflictOfInterests,
    showRatingRequestInProgress,
  };
};
